import React, { useState } from 'react';

import ContractorSchedulingIndexTableRowItem from './ContractorSchedulingIndexTableRowItem';

import ChevronDownIcon from 'Assets/icons/chevron-down.svg';
import ChevronUpIcon from 'Assets/icons/chevron-up.svg';

export default function ContractorSchedulingIndexTableRow(props) {
    const [showPacksChild, setShowPacksChild] = useState(false);

    return (
        <>
            <tr className="text-blue" onClick={() => setShowPacksChild(!showPacksChild)}>
                <td colSpan="11">
                    <div className="tw-flex tw-flew-row tw-gap-1 tw-items-center">
                        {props.packChildVenue.venue_name}
                        {showPacksChild ? <ChevronUpIcon className="tw-w-2.5 tw-h-2.5 tw-ml-2" /> : <ChevronDownIcon className="tw-w-2.5 tw-h-2.5 tw-ml-2" />}
                    </div>
                </td>
            </tr>
            {showPacksChild &&
                props.packChildVenue.items.map((packChild) => {
                    return <ContractorSchedulingIndexTableRowItem key={packChild.key} packChild={packChild} />;
                })}
        </>
    );
}
